import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import NavTitle from "./NavTitle";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_API_URL;

const Category = ({ gender, closeSidebar, isOpen, toggleCategory }) => {
  const [brands, setBrands] = useState([]);
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  // Derive selected category from URL
  const selectedCategoryId =
    searchParams.get("gender") === gender
      ? parseInt(searchParams.get("subcategory")) || null
      : null;

  useEffect(() => {
    if (isOpen) {
      fetch(`${BASE_URL}/api/sous-categories/gender/${gender}/`)
        .then((response) => response.json())
        .then((data) => setBrands(data))
        .catch((error) => console.error("Error fetching categories:", error));
    }
  }, [gender, isOpen]);

  const handleCategorySelect = (item) => {
    // Store selection in URL — Shop.js will react and fetch products
    setSearchParams((params) => {
      params.set("gender", gender);
      params.set("subcategory", item.id);
      params.set("page", 1);
      return params;
    });
    if (window.innerWidth < 1024) {
      closeSidebar();
    }
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow-lg">
      <div onClick={toggleCategory} className="cursor-pointer mb-4">
        <NavTitle title={`${t("Shopby")} ${t(gender)} ${t("Category")}`} icons={true} />
      </div>

      {isOpen && (
        <motion.div
          initial={{ x: -20, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.3 }}
        >
          <ul className="space-y-2 text-sm lg:text-base text-gray-700">
            {brands.map((item) => (
              <li
                key={item.id}
                className={`px-4 py-3 transition-all duration-300 cursor-pointer rounded-md flex justify-between items-center ${selectedCategoryId === item.id
                    ? "bg-gray-200 text-gray-900 font-semibold"
                    : "text-gray-600 hover:bg-gray-100"
                  }`}
                onClick={() => handleCategorySelect(item)}
              >
                <span>{item.name}</span>
              </li>
            ))}
          </ul>
        </motion.div>
      )}
    </div>
  );
};

export default Category;
